/**
 * App download buttons — "Coming soon" tiles with platform glyphs (Apple & Google Play).
 */
import { useI18n } from "../lib/i18n";

const AppleGlyph = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
  </svg>
);

const GooglePlayGlyph = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
    <defs>
      <linearGradient id="gpG" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#34D399"/>
        <stop offset="1" stopColor="#22E8D5"/>
      </linearGradient>
      <linearGradient id="gpB" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#60A5FA"/>
        <stop offset="1" stopColor="#3B82F6"/>
      </linearGradient>
      <linearGradient id="gpR" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#F87171"/>
        <stop offset="1" stopColor="#EF4444"/>
      </linearGradient>
      <linearGradient id="gpY" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#FBBF24"/>
        <stop offset="1" stopColor="#F59E0B"/>
      </linearGradient>
    </defs>
    <path d="M3.6 2.4c-.4.3-.6.8-.6 1.4v16.4c0 .6.2 1.1.6 1.4l9-9-9-10.2z" fill="url(#gpB)"/>
    <path d="M16 8.6l-3.1-1.8L3.6 2.4 12.6 12.2 16 8.6z" fill="url(#gpG)"/>
    <path d="M12.6 12.2l-9 9.4 9.3-5.3 3.1-1.8-3.4-2.3z" fill="url(#gpR)"/>
    <path d="M20.7 11.1l-4.7-2.5-3.4 3.6 3.4 2.3 4.7-2.4c1-.6 1-2 0-2.5z" fill="url(#gpY)"/>
  </svg>
);

function PlaceholderTile({ label, sub, testId, glyph }) {
  return (
    <div
      className="inline-flex items-center gap-3 rounded-2xl border border-white/20 bg-ink-deep/85 backdrop-blur-md px-4 py-3 select-none shadow-[0_8px_24px_rgba(0,0,0,0.4)] hover:bg-ink-deep/95 transition"
      data-testid={testId}
    >
      <span className="text-bone shrink-0 w-7 h-7 grid place-items-center">{glyph}</span>
      <div className="leading-tight">
        <div className="text-[10px] uppercase tracking-widest text-bone/70">{sub}</div>
        <div className="text-[14px] font-semibold text-bone">{label}</div>
      </div>
    </div>
  );
}

export function GooglePlayBadge() {
  const { t } = useI18n();
  return <PlaceholderTile label="Google Play" sub={t("common.coming_soon", "Coming soon")} testId="badge-google-play" glyph={<GooglePlayGlyph />} />;
}

export function AppStoreBadge() {
  const { t } = useI18n();
  return <PlaceholderTile label="App Store" sub={t("common.coming_soon", "Coming soon")} testId="badge-app-store" glyph={<AppleGlyph />} />;
}
